// FILE: src/components/PasswordField.jsx
// A password TextField with a show / hide button (an eye icon with an
// accessible name and aria-pressed). Pass `toggleLabel` when a page has
// two of them so each button has its own name.
import { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

export default function PasswordField({ toggleLabel = "Show password", slotProps = {}, ...props }) {
  const [shown, setShown] = useState(false);
  return (
    <TextField
      {...props}
      type={shown ? "text" : "password"}
      slotProps={{
        ...slotProps,
        htmlInput: { autoCapitalize: "off", spellCheck: false, ...slotProps.htmlInput },
        input: {
          ...slotProps.input,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShown((v) => !v)} aria-label={toggleLabel} aria-pressed={shown} edge="end">
                {shown ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  );
}
